export const getMiles = (meters) => {
  return Math.round((meters*0.000621371192)* 100) / 100;
}
export const getMeters = (miles) => {
  return Math.round((miles*1609.344)* 100) / 100;
}